import { render, staticRenderFns } from "./DialogProductCodes.vue?vue&type=template&id=08e96186"
import script from "./DialogProductCodes.vue?vue&type=script&lang=js"
export * from "./DialogProductCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports